{
  "version": 1,
  "asset_id": "03ab01e3-9a01-4688-8977-4fc1d2f7ba18",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/03ab01e3-9a01-4688-8977-4fc1d2f7ba18/sleeve-gastrectomy-es-v2-800.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/03ab01e3-9a01-4688-8977-4fc1d2f7ba18/sleeve-gastrectomy-es-v2-800.webp",
  "original_filename": "sleeve-gastrectomy-es-v2-800.webp",
  "size": 44542,
  "content_type": "image/webp",
  "created_at": "2026-09-25T13:06:42Z"
}
